import { gql } from '@mineko/graphql-client';

export default gql`
  query ($input: ProductSelectionInput!) {
    ProductSelection(input: $input) {
      id
      price
      name
      initialPrice
      type
      categoryId
      requiresPayment
      highlighted
      unavailable
      hidePrice
      requiresInsuranceProof
      requiresBillingConsent
      attributesIncluded {
        id
        description
        metaDescription
      }
      attributesExcluded {
        id
        description
        metaDescription
      }
      attributesHighlighted {
        id
        description
        metaDescription
      }
      integratedPartner {
        id
        name
        referenceLabelCase
        referenceLabelContract
        referenceLabelVoucher
        type
        conditionText
        preResultPromoText
        partnerSettings {
          productLogo
        }
        options
      }
      defaultSelected
    }
  }
`;
